import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LogIn, Rocket } from "lucide-react";
import apiClient from "@/lib/apiClient";
import logo from "@/assets/logo.png";

export const PreviewLayout = ({ children, tab }) => {
  const [flags, setFlags] = useState({ browse_tournaments: false, browse_leaderboards: false });

  useEffect(() => {
    apiClient.get("/public/guest-flags").then(({ data }) => setFlags(data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen grid-overlay">
      <header className="sticky top-0 z-20 glass border-b border-white/10">
        <div className="flex items-center justify-between px-4 sm:px-6 h-16 max-w-7xl mx-auto">
          <Link to="/" className="flex items-center gap-2">
            <img src={logo} alt="Pit Lane Lounge" className="h-9 w-auto object-contain" />
          </Link>
          <nav className="hidden sm:flex items-center gap-2">
            <PreviewTab to="/book" label="Book" active={tab === "book"} />
            {flags.browse_tournaments && <PreviewTab to="/preview/tournaments" label="Tournaments" active={tab === "tournaments"} />}
            {flags.browse_leaderboards && <PreviewTab to="/preview/leaderboards" label="Leaderboards" active={tab === "leaderboards"} />}
          </nav>
          <div className="flex items-center gap-2">
            <Link to="/login" className="neon-outline-btn px-4 py-2 text-xs" data-testid="preview-signin">
              <LogIn className="w-3.5 h-3.5" /> Sign In
            </Link>
            <Link to="/register" className="neon-btn px-4 py-2 text-xs" data-testid="preview-register">
              <Rocket className="w-3.5 h-3.5" /> Join
            </Link>
          </div>
        </div>
        {(flags.browse_tournaments || flags.browse_leaderboards) && (
          <div className="sm:hidden flex items-center justify-center gap-2 pb-2 max-w-7xl mx-auto">
            <PreviewTab to="/book" label="Book" active={tab === "book"} />
            {flags.browse_tournaments && <PreviewTab to="/preview/tournaments" label="Tournaments" active={tab === "tournaments"} />}
            {flags.browse_leaderboards && <PreviewTab to="/preview/leaderboards" label="Leaderboards" active={tab === "leaderboards"} />}
          </div>
        )}
      </header>
      <main className="px-4 sm:px-6 lg:px-10 py-8 max-w-7xl mx-auto w-full">{children}</main>
    </div>
  );
};

const PreviewTab = ({ to, label, active }) => (
  <Link
    to={to}
    className="px-3.5 py-1.5 rounded-lg font-display uppercase tracking-widest text-[11px] font-bold transition-all"
    style={active
      ? { background: "linear-gradient(90deg, rgba(0,229,255,0.18), rgba(139,92,246,0.14))", border: "1px solid rgba(0,229,255,0.4)", color: "#00e5ff" }
      : { background: "transparent", border: "1px solid transparent", color: "#94a3b8" }}
  >
    {label}
  </Link>
);
